<script setup lang="ts">
import { ref, computed, watch } from "vue";
import { useForm } from "vee-validate";
import { useErrors } from "@/utils/api-functions";

//@ts-ignore
import FormInput from "@/components/form/input.vue";
//@ts-ignore
import FormCheckbox from "@/components/form/checkbox.vue";
//@ts-ignore
import FormCombobox from "@/components/form/combobox.vue";
//@ts-ignore
import Submit from "@/components/form/submit.vue";
import * as Yup from "yup";
import { nl } from "yup-locales";
import { useApiStore } from "@/stores/api";
import { useAppStore } from "@/stores/app";

const appStore = useAppStore();
const apiErrors = useErrors();
const apiStore = useApiStore();

const props = withDefaults(defineProps<{ tags: any; mailchimpGroupId: string; mailchimpIds: string[]; title: string; description: string; url: string }>(), {
    mailchimpIds: () => [],
    tags: () => [],
});

const success = ref(false);
const loading = ref(false);
const showUrl = ref(false);
const component = ref<HTMLDivElement>();

Yup.setLocale(nl);

const { handleSubmit, isSubmitting, values } = useForm({
    initialValues: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        href: window.location.href,
        pathname: window.location.pathname,
        tags: props.tags,
        mailchimp_group_id: props.mailchimpGroupId,
        mailchimp_ids: props.mailchimpIds,
    },
    validationSchema: Yup.object({
        first_name: Yup.string().required().label("Voornaam"),
        last_name: Yup.string().required().label("Achternaam"),
        email: Yup.string().email().required().label("Email"),
        phone: Yup.string()
            .matches(/(((\+|00)3[12][ ]?(?:\(0\)[ ]?)?)|0){1}(4(60|[789]\d)\/?(\s?\d{2}\.?){2}(\s?\d{2})|(\d\/?\s?\d{3}|\d{2}\/?\s?\d{2})(\.?\s?\d{2}){2})/, "Telefoonnummer is ongeldig")
            .required()
            .label("Telefoonnummer"),
        href: Yup.string().required(),
        pathname: Yup.string().required(),
        tags: Yup.string().label("Tags"),
        mailchimp_group_id: Yup.string().label("Mailchimp group ids"),
        mailchimp_ids: Yup.array().label("Mailchimp ids"),
    }),
});

const dynamicallyCreateAnchorAndNavigate = function (url: any) {
    let anchorElement = document.createElement("a");
    anchorElement.href = url;
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
};

const openInNewTab = function (url: any) {
    dynamicallyCreateAnchorAndNavigate(url);
};

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    try {
        loading.value = true;
        showUrl.value = false;

        // @ts-ignore
        await apiStore.downloadBrochure(values);

        // @ts-ignore
        if (window.hasOwnProperty("dataLayer") && dataLayer) {
            // @ts-ignore
            dataLayer.push({
                event: "cf7submission",
                formId: "1912",
                response: [
                    { name: "first_name", value: values.first_name },
                    { name: "last_name", value: values.last_name },
                    { name: "email", value: values.email },
                    { name: "phone", value: values.phone },
                    { name: "href", value: window.location.href },
                    { name: "pathname", value: window.location.pathname },
                ],
            });
        }

        success.value = true;

        // download url
        showUrl.value = true;
        openInNewTab(props.url);

        setTimeout(resetForm, 500);
    } catch (error) {
        apiErrors.parse(error);
    } finally {
        loading.value = false;
    }
});
</script>

<template>
    <div>
        <div v-if="!success" class="text-white font-medium mb-[32px] text-24" v-html="title"></div>
        <div v-if="!success" class="text-beige-100 mb-[16px]" v-html="description"></div>

        <form id="brochure_form" key="form" v-if="!success" @submit="onSubmit" class="grid md:min-w-[500px]">
            <component :is="apiErrors.render()" :data="apiErrors.get()"></component>

            <form-input name="first_name" label-position="left" label-class="w-[130px]" type="text" label="Voornaam"></form-input>
            <form-input name="last_name" label-position="left" label-class="w-[130px]" type="text" label="Achternaam"></form-input>
            <form-input name="email" label-position="left" label-class="w-[130px]" type="email" label="Email"></form-input>
            <form-input name="phone" label-position="left" label-class="w-[130px]" type="text" label="Telefoonnummer"></form-input>

            <div class="mt-[64px] ml-auto">
                <submit :disabled="success" :loading="isSubmitting || loading">Verstuur</submit>
            </div>
        </form>

        <div key="success" class="flex flex-1 w-full text-white" v-else>
            <p class="text-left mb-[32px]">Bedankt, je kan nu de brochure bekijken. Maak zeker een afspraak als je nog meer info wenst of als je graag eens hoort welke concrete mogelijkheden nog bij jou zouden passen.</p>
        </div>
    </div>
</template>
